<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="markdown-container">
    <div v-html="rendered"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMarkdown } from './useMarkdown';
import 'katex/dist/katex.min.css';

const { render } = useMarkdown();

const props = defineProps<{ input: string }>();

const rendered = computed(() => render(props.input));
</script>

<style>
.markdown-container h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
}

.markdown-container h2 {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
}

.markdown-container h3 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
}

.markdown-container h4 {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
}

.markdown-container p {
  /* display: inline; */
  line-height: 1.5rem;
}

.markdown-container ol {
  list-style: decimal;
}
.markdown-container ul {
  list-style: disc;
}
.markdown-container li {
  margin-left: 1rem;
}

.markdown-container a {
  color: var(--color-primary-500);
  text-decoration: underline;
}
.markdown-container pre {
  white-space: pre-wrap;
}
</style>
